/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import {http} from 'hiya-common/src/utils/axios'
import RouletteFomoBg from './Fomo/images/rouletteBg.png'
import slotFomoBg from './Fomo/images/slotBg.png'
import FomoBg from './Fomo/images/bg.png'

export enum barGameName {
  GreedyPro = 'GreedyPro',
  GreedyHiya = 'GreedyHiya',
  LuckySlot = 'LuckySlot',
  roulette = 'roulette',
  HorseGame = 'HorseGame',
  TeenPatti = 'TeenPatti',
  guessbox = 'guessbox',
  fruitSlot = 'fruitSlot',
  fruitTols = 'fruitTols',
  GreedyBox = 'GreedyBox',
  LuckyTols = 'LuckyTols',
  GreedyRocket = 'GreedyRocket',
  GoldMiner = 'GoldMiner',
  GreedyEgg = 'GuessGift',
  GuessGift = 'GuessGift',
  LuckyBigWheel = 'LuckyBigWheel',
  GreedyMold = 'GreedyMold',
  JustGame = 'JustGame',
  WorldCup = 'WorldCup',
  RoyalWild = 'RoyalWild',
  GreedySports = 'GreedySports',

  gggmmmmeeeee = 'GoldMiner',
  ggghhhhaaaaa = 'GreedyHiya',
  gggrrrrttttt = 'GreedyRocket',
  gggppppooooo = 'GreedyPro',
  gggyyyybbbbb = 'GreedyBox',
  lllbbbblllll = 'LuckyBigWheel',
  wwwccccppppp = 'WorldCup',
  gggbbbbxxxxx = 'guessbox',
  gggggggttttt = 'GuessGift',
  fffssssttttt = 'fruitSlot',
  rrrlllleeeee = 'roulette',
  lllssssttttt = 'LuckySlot',
  hhhggggeeeee = 'HorseGame',
  tttppppiiiii = 'TeenPatti',
  rrrllllddddd = 'RoyalWild',
  gggssssttttt0303 = 'GreedySports',
}

export const getToLowerCurBarName = (): barGameName => {
  try {
    let res
    for (const key in barGameName) {
      const reg = new RegExp(`\\b${key.toLowerCase()}\\b`, 'g')
      if (reg.test(window.location.pathname?.toLowerCase())) {
        res = key
      }
    }
    return barGameName?.[res] || barGameName.GreedyBox
  } catch (error) {
    return barGameName.GreedyBox
  }
}

async function get_function_list_service(room_id) {
  const res = await http.post('/live/room/function_list', {
    ...window.store.getState().env.deviceinfo,
    from: 'app',
    room_id,
  })
  return res.data.data
}

export enum GameType {
  猜宝箱 = 1,
  greedyhiya = 2,
  tp = 3,
  新转盘 = 4,
  slot = 5,
  greedypro = 6,
  roulette = 12,
  greedybox = 13,
  Greedy模板游戏 = 14,
}

// 参考 http://wiki.xunlei.cn/pages/viewpage.action?pageId=155170308
export const getGuessCoinsType = () => {
  const obj = {
    [barGameName.GreedyHiya]: 2,
    [barGameName.TeenPatti]: 3,
    [barGameName.LuckyBigWheel]: 4,
    [barGameName.GreedyPro]: 6,
    [barGameName.fruitSlot]: 7,
    [barGameName.fruitTols]: 7,
    [barGameName.HorseGame]: 8,
    [barGameName.GreedyEgg]: 9,
    [barGameName.LuckySlot]: 11,
    [barGameName.LuckyTols]: 11,
    [barGameName.roulette]: 12,
    [barGameName.guessbox]: 13,
    [barGameName.GreedyBox]: 13,
    [barGameName.GreedyMold]: 14,
    [barGameName.GoldMiner]: 15,
    [barGameName.GreedyRocket]: 16,
    [barGameName.RoyalWild]: 21,
  }
  return obj[getToLowerCurBarName()]
}

export const getFunctionGameIndex = async (
  room_id: number,
  searchStr: barGameName
) => {
  const {play_list = []} = await get_function_list_service(room_id)
  const index = play_list
    .filter((item) => item.is_show)
    .findIndex((item) => new RegExp(`\\b${searchStr}\\b`, 'gi').test(item.url))
  return index === -1 ? 0 : index
}

export const getFunctionGame = async (
  room_id: number,
  searchStr: barGameName
) => {
  const {play_list = []} = await get_function_list_service(room_id)
  const index = play_list
    .filter((item) => item.is_show)
    .findIndex((item) => new RegExp(`\\b${searchStr}\\b`, 'gi').test(item.url))
  return index === -1 ? null : play_list[index]
}

// 给fomo用的距离顶部高度
export const getFomoGuideTop = () => {
  const obj = {
    [barGameName.roulette]: 20,
    [barGameName.LuckySlot]: 104,
    [barGameName.HorseGame]: 0,
    [barGameName.guessbox]: 0,
    [barGameName.GreedyPro]: -10,
    [barGameName.TeenPatti]: 0,
    [barGameName.GreedyHiya]: 0,
    [barGameName.GreedyBox]: 66,
    [barGameName.LuckyTols]: 104,
  }
  return obj[getToLowerCurBarName()]
}

export const getFomoBackground = () => {
  const obj = {
    [barGameName.roulette]: RouletteFomoBg,
    [barGameName.LuckySlot]: slotFomoBg,
    [barGameName.HorseGame]: FomoBg,
    [barGameName.guessbox]: FomoBg,
    [barGameName.GreedyPro]: FomoBg,
    [barGameName.TeenPatti]: FomoBg,
    [barGameName.GreedyHiya]: FomoBg,
    [barGameName.GreedyBox]: FomoBg,
    [barGameName.LuckyTols]: slotFomoBg,
  }
  return obj[getToLowerCurBarName()]
}

export enum GameTypeEnum {
  猜宝箱 = 1,
  greedyHiya = 2,
  tp = 3,
  新转盘 = 4,
  slot = 5,
  greedypro = 6,
  luckSlot = 11,
  roulette = 12,
  greedyBox = 13,
  royalWild = 21,
}

export const getLogFrom = () => {
  const obj = {
    [barGameName.fruitSlot]: 'yummy fruit',
    [barGameName.roulette]: 'roulette',
    [barGameName.LuckySlot]: 'lucky slots',
    [barGameName.HorseGame]: 'horse',
    [barGameName.guessbox]: 'greedy box',
    [barGameName.GreedyPro]: 'greedy pro',
    [barGameName.TeenPatti]: 'teenpatti',
    [barGameName.GreedyHiya]: 'greedy hiya',
    [barGameName.GreedyBox]: 'greedy box',
    [barGameName.LuckyTols]: 'lucky slots',
    [barGameName.GreedyRocket]: 'crush rocket',
    [barGameName.GoldMiner]: 'GoldMiner',
    [barGameName.LuckyBigWheel]: 'LuckyBigWheel',
    [barGameName.WorldCup]: 'WorldCup',
    [barGameName.GuessGift]: 'GuessGift',
    [barGameName.RoyalWild]: 'royal wild',
    [barGameName.GreedySports]: 'greedy_sports',
    // [barGameName.gggmmmmeeeee]: 'GoldMiner',
    // [barGameName.ggghhhhaaaaa]: 'GreedyHiya',
    // [barGameName.gggrrrrttttt]: 'GreedyRocket',
    // [barGameName.gggppppooooo]: 'GreedyPro',
    // [barGameName.gggyyyybbbbb]: 'GreedyBox',
    // [barGameName.lllbbbblllll]: 'LuckyBigWheel',
    // [barGameName.wwwccccppppp]: 'WorldCup',
    // [barGameName.gggbbbbxxxxx]: 'guessbox',
    // [barGameName.gggggggttttt]: 'GuessGift',
    // [barGameName.fffssssttttt]: 'fruitSlot',
    // [barGameName.rrrlllleeeee]: 'roulette',
    // [barGameName.lllssssttttt]: 'LuckySlot',
    // [barGameName.hhhggggeeeee]: 'HorseGame',
    // [barGameName.tttppppiiiii]: 'TeenPatti',
  }
  return obj[getToLowerCurBarName()]
}

// 解析帧率list获取60s内的平均值
export const analyzeArray = (arr) => {
  if (!arr || !arr?.length) {
    return null
  }

  let sum = 0
  let min = Infinity
  let freezeCount = 0

  for (let i = 0; i < arr.length; i += 1) {
    sum += arr[i]
    if (arr[i] < min) {
      min = arr[i]
    }

    if (i < arr.length - 1) {
      if (arr[i] < 5 && arr[i + 1] < 5) {
        freezeCount += 2
        i += 1
      } else if (arr[i] < 20 && arr[i + 1] < 20) {
        freezeCount += 1
        i += 1
      }
    }
  }

  const average = sum / arr.length

  return {
    average,
    min,
    freezeCount,
  }
}
